import { render, staticRenderFns } from "./LogAlteracaoDados.vue?vue&type=template&id=9349a694&scoped=true"
import script from "./LogAlteracaoDados.vue?vue&type=script&lang=js"
export * from "./LogAlteracaoDados.vue?vue&type=script&lang=js"
import style0 from "./LogAlteracaoDados.vue?vue&type=style&index=0&id=9349a694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9349a694",
  null
  
)

export default component.exports